import './App.css';
import { Router } from './Routes';
import { BrowserRouter } from 'react-router-dom';

function App() {
  return (
    <>
      <BrowserRouter>
        {/* <Sidebar> */}
          <Router />
        {/* </Sidebar> */}
      </BrowserRouter>
    </>
  );
}

export default App;
